const deepCopy = (map) => JSON.parse(JSON.stringify(map))

export default deepCopy
